// extracted by mini-css-extract-plugin
export default {"recos":"c2-z","productCardOverride":"d2-z","rowHasBadge":"e2-z"};